module.exports = __webpack_public_path__ + "img/apply.24530e03.png";